import { SaleChangeStatusEnum } from '@src/core/buyerApiClient';

interface Params {
  hasMultipleVouchers: boolean;
  hasVoucherSplitPolicy: boolean;
  canShowReschedule: boolean;
  lastSaleChangeStatus?: SaleChangeStatusEnum;
}

export function shouldShowReservationActions({
  hasMultipleVouchers,
  hasVoucherSplitPolicy,
  canShowReschedule,
  lastSaleChangeStatus,
}: Params): boolean {
  return (
    !hasMultipleVouchers ||
    hasVoucherSplitPolicy ||
    canShowReschedule ||
    lastSaleChangeStatus === SaleChangeStatusEnum.Pending
  );
}
